import React from "react";
import Header from "../../components/layout/Header/Header";
import { useNavigate } from "react-router-dom";
import { Container, RedText, Text1, Text2, Text3 } from "./styles";
import Btn from "../../components/UI/Btn404/Btn";

const NotFound = () => {
  const navigate = useNavigate();

  const handleSubmit = () => {
    navigate("/");
  };

  return (
    <>
      <Container>
        <Text1>404 ОШИБКА</Text1>
        <Text2>
          Страница <RedText>не найдена</RedText>
        </Text2>
        <Text3>Такая страница не существует либо она была удалена.</Text3>
        <Btn onClick={handleSubmit} text="Главная страница" />
      </Container>
    </>
  );
};
export default NotFound;
